module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/tracking_mobile-3ae6092831edd3f5bcae1b74fe94488e.png";